import * as React from 'react';
import Svg, { Circle, ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

const SvgComponent = () => (
    <Svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
        <G clip-path="url(#clip0_59345_11812)">
            <Circle
                cx="40"
                cy="40"
                r="38"
                fill={ds.colorValue.icon.primary}
                stroke={ds.colorValue.icon.primary}
                stroke-width="4"
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.1421 48.6274L56.7696 26L59.598 28.8284L34.1421 54.2843L20 40.1421L22.8284 37.3137L34.1421 48.6274Z"
                fill={designSystem.colors.neutral900}
            />
        </G>
        <Defs>
            <ClipPath id="clip0_59345_11812">
                <Rect width="80" height="80" fill={ds.colorValue.icon.primary} />
            </ClipPath>
        </Defs>
    </Svg>
);
export { SvgComponent as CheckmarkLargeWhite };
